import { Entity, Mate, Moment } from "./entity";

/** 硬币获取 */
// 用户每天-每种类型-获取硬币的记录
export interface CoinQuestUser extends Entity {
  coinQuestId: CoinQuestTaskType;
  userId: number;
  obtainAmount: number; // 获取数量
  dtAward: string;
  coinQuest: CoinQuest; // 获取硬币的方式
  user: User;
  $itemzz: []; // 硬币获取记录
}

// 获取硬币的方式枚举
export enum CoinQuestTaskType {
  Visit = 1, // 签到
  Send5Emoji = 2, // 点赞
  Get3Reply = 3, // 评论
  SetBio = 4, // 设置个人简介
  SetAvatar = 5, // 设置头像
}

export enum CoinQuestType {
  DailyTask = 1,
  WeeklyTask = 2,
  MonthlyTask = 3,
  YearlyTask = 4,

  Award = 5,
  Tip = 6,
  CommunityActivity = 7,
  OneTimeTask = 8,
  ReviewerTicket = 9,
}

export enum CoinQuestRepeatType {
  OneTime = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
  Always = 10,
}

// 获取硬币的方法
export interface CoinQuest extends Entity {
  id: CoinQuestTaskType;
  name: string;
  coinAmount: number;
  requireAmount: number;
  repeatType: CoinQuestRepeatType;
  type: CoinQuestType;
}

/** 硬币收支 */
const modelPrefix = "App\\Models";

export enum CoinBalanceRecordEntityType {
  Game = `${modelPrefix}\\GalGame`,
  Mate = `${modelPrefix}\\Mate`,
  StoryBook = `${modelPrefix}\\StoryBook`,
  Story = `${modelPrefix}\\Story`,
  Moment = `${modelPrefix}\\Moment`,
  Collection = `${modelPrefix}\\Collection`,
}

export interface CoinBalanceRecord extends Entity {
  userId: number;
  coinAmount: number; // 花费
  type: CoinQuestType; // 花费类型
  entityType: CoinBalanceRecordEntityType; // 花费的实体类型
  entityId: number;
  entity: CoinQuestUser;
  title: string;
}

// 硬币支出记录
export interface CoinExpenditure extends CoinBalanceRecord {}

// 硬币收入记录
export interface CoinIncome extends CoinBalanceRecord {}

export interface CoinVote extends Entity {
  userId: number;
  amount: number;
  entityType: CoinBalanceRecordEntityType;
  entityId: number;
  text: string;
  user: User;
  entity: Mate | Story | StoryBook | Moment | GalGame;
  mate?: Mate;
  isAnonymous: boolean;
  isGolden: 0 | 1;
}
